export const BARCODE_PRODUCT_PATTERNS = {
  UPC_A: "UPC_A",
  UPC_E: "UPC_E",
  EAN_13: "EAN_13",
  EAN_8: "EAN_8"
} as const;
export type BarcodeProductPattern = keyof typeof BARCODE_PRODUCT_PATTERNS;

const KANPLA_PATTERNS = {
  QR_CHILD_ID: "QR_CHILD_ID",
  QR_ORDER_ID: "QR_ORDER_ID"
} as const;
export type KanplaPattern = keyof typeof KANPLA_PATTERNS;

export const CODE_PATTERNS = {
  ...BARCODE_PRODUCT_PATTERNS,
  ...KANPLA_PATTERNS,
  GENERIC: "GENERIC"
} as const;
export type CodePattern = keyof typeof CODE_PATTERNS;

/**
 * Individual regex patterns for different code formats.
 */
export const CODE_PATTERNS_REGEX: Record<CodePattern, RegExp> = {
  /**
   * This regex matches for any QR code with this format START<childId>END.
   * Allows for trailing alphanumeric characters after END (e.g., ArrowDown from scanner).
   */
  QR_CHILD_ID: /^START(?<childId>[a-zA-Z0-9?]+)END(?=[a-zA-Z0-9]*$)/,

  /**
   * This regex matches for any ticket QR code with this format TICKET<orderData>END.
   * Allows for trailing alphanumeric characters after END (e.g., ArrowDown from scanner).
   */
  QR_ORDER_ID: /^TICKET(?<orderId>[a-zA-Z0-9+/=]+)END(?=[a-zA-Z0-9]*$)/,

  /**
   * This regex matches for any UPC-A barcode with this format <digits>123456789012.
   */
  UPC_A: /^[0-9]{12}$/, // Universal Product Code - Version A

  /**
   * This regex matches for any UPC-E barcode with this format <digits>12345678.
   */
  UPC_E: /^[0-9]{8}$/, // Universal Product Code - Version E (compressed)

  /**
   * This regex matches for any EAN-8 barcode with this format <digits>1234567.
   */
  EAN_8: /^[0-9]{8}$/, // European Article Number (8 digits)

  /**
   * This regex matches for any EAN-13 barcode with this format <digits>1234567890123.
   */
  EAN_13: /^[0-9]{13}$/, // European Article Number

  /**
   * This regex matches for any generic barcode .
   */
  GENERIC: /^[A-Za-z0-9\-./+\s]{1,}$/ // Variable length alphanumeric with symbols
} as const;
